import cn from 'classnames';
import React from 'react';

import {ITableReportMenu} from 'store/slices/table-report-slice/table-report-slice-types';

import {AsideNode} from '../aside-node';

import './aside-dropdown.less';

interface IAsideDropdownProps {
    parent: ITableReportMenu;
    submenus: ITableReportMenu[];
    depth: number;
    open: boolean;
    activeMenu: ITableReportMenu | undefined;
    onRowClick: (menu: ITableReportMenu) => void;
}

export const AsideDropdown = ({
    parent,
    submenus,
    depth,
    open,
    activeMenu,
    onRowClick,
}: IAsideDropdownProps) => {
    const newDepth = depth + 1;

    return (
        <div
            className={`aside-dropdown${cn(open && ' open')}`}
        >
            {submenus.map(submenu => (
                <AsideNode
                    key={submenu.name}
                    menu={submenu}
                    name={submenu?.name || parent.name}
                    depth={newDepth}
                    activeMenu={activeMenu}
                    onRowClick={onRowClick}
                />
            ))}
        </div>
    );
};
